export const newPassword = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5209_28074)">
<path d="M102 0H18C8.05888 0 0 8.05888 0 18V102C0 111.941 8.05888 120 18 120H102C111.941 120 120 111.941 120 102V18C120 8.05888 111.941 0 102 0Z" fill="#282B34"/>
<path d="M81.0938 50.1562V41.4844C81.0938 12.6562 38.9062 12.6562 38.9062 41.4844V50.1562" fill="#282B34"/>
<path d="M81.0938 50.1562V41.4844C81.0938 12.6562 38.9062 12.6562 38.9062 41.4844V50.1562" stroke="#E0E0E0" stroke-width="6"/>
<path d="M86.5781 49.2188H32.9531C29.6394 49.2188 26.9531 51.905 26.9531 55.2188V92.4375C26.9531 95.7512 29.6394 98.4375 32.9531 98.4375H86.5781C89.8918 98.4375 92.5781 95.7512 92.5781 92.4375V55.2188C92.5781 51.905 89.8918 49.2188 86.5781 49.2188Z" fill="url(#paint0_linear_5209_28074)"/>
<path d="M60 75.9375C63.6244 75.9375 66.5625 72.9994 66.5625 69.375C66.5625 65.7506 63.6244 62.8125 60 62.8125C56.3756 62.8125 53.4375 65.7506 53.4375 69.375C53.4375 72.9994 56.3756 75.9375 60 75.9375Z" fill="#282B34"/>
<path d="M61.4062 69.375H58.5938L54.8438 85.5469H65.1562" fill="#282B34"/>
</g>
<defs>
<linearGradient id="paint0_linear_5209_28074" x1="26.9531" y1="73.8281" x2="92.5781" y2="73.8281" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#99F1FF"/>
</linearGradient>
<clipPath id="clip0_5209_28074">
<rect width="120" height="120" fill="white"/>
</clipPath>
</defs>
</svg>
`;
